export default [
  {
    path: '/initialinformationdeclaration',
    name: 'initialInformationDeclaration',
    component: () => import('@/views/initialInformationDeclaration/InitialInformationDeclaration.vue'),
    meta: {},
  },
  {
    path: '/license-expire-date',
    name: 'ExpireDateContent',
    component: () => import('@/views/dictionary/license/ExpireDateContent.vue'),
    meta: {},
  },
];
